import React, { useState } from "react";
import { inputCls } from "./admin/ui";

export default function TwoFactorStep({ onVerify, onCancel, loading }) {
  const [useRecovery, setUseRecovery] = useState(false);
  const [value, setValue] = useState("");

  const submit = (e) => {
    e.preventDefault();
    onVerify(useRecovery ? { recovery: value.trim() } : { code: value.trim() });
  };

  return (
    <form onSubmit={submit} data-testid="twofa-login-form" className="bg-[#202127] border border-[#35353B] rounded-lg p-6 space-y-4">
      <div>
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37] mb-1">Verifikasi 2 Langkah</div>
        <p className="text-sm text-[#A8A8AD]">
          {useRecovery ? "Masukkan salah satu recovery code Anda (format XXXX-XXXX)." : "Buka Google Authenticator dan masukkan kode 6 digit untuk MQL Group."}
        </p>
      </div>
      <input data-testid="twofa-login-code-input" autoFocus required value={value}
        inputMode={useRecovery ? "text" : "numeric"} maxLength={useRecovery ? 20 : 6} pattern={useRecovery ? undefined : "\\d{6}"}
        placeholder={useRecovery ? "ABCD-EFGH" : "123456"} onChange={(e) => setValue(e.target.value)}
        className={`${inputCls} text-center text-xl tracking-[0.4em] font-mono`} />
      <button data-testid="twofa-login-submit-btn" type="submit" disabled={loading}
        className="w-full bg-[#D4AF37] text-[#101114] hover:bg-[#F2D98D] disabled:opacity-50 transition-colors font-bold rounded-sm py-2.5">
        {loading ? "Memverifikasi..." : "Verifikasi"}
      </button>
      <div className="flex justify-between text-xs">
        <button type="button" data-testid="twofa-toggle-recovery-btn" onClick={() => { setUseRecovery(!useRecovery); setValue(""); }} className="text-[#D4AF37] hover:underline">
          {useRecovery ? "Pakai kode Authenticator" : "Pakai recovery code"}
        </button>
        <button type="button" data-testid="twofa-cancel-btn" onClick={onCancel} className="text-[#A8A8AD] hover:text-[#F5F3ED]">Batal</button>
      </div>
    </form>
  );
}
